export default {
  init: () => {
    const container = document.getElementsByClassName('js-search')[0];
    const button = container.getElementsByClassName('js-search-btn')[0];
    const form = container.getElementsByClassName('js-search-form')[0];

    button.addEventListener('click', () => {
      form.classList.toggle('search__form--active');
    });
  },
};
